import { render } from "./BaseDialogConfirmation.vue?vue&type=template&id=6fd0f3ec"
import script from "./BaseDialogConfirmation.vue?vue&type=script&lang=js"
export * from "./BaseDialogConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__